import jsSHA from "jssha"
import { routes, productSummarySelection } from "./constants";
import styles from './utils.module.scss'

const rootType = "ROOT_OPERATOR";

const getRootOperator = (label) => {
    switch (label) {
        case "AND":
            return "&&"
        case "OR":
            return "||"
    }
}

export function makeTree(nodes, rootValue) {
    const node = {
        leftNode: null,
        nodeType: rootType,
        nodeValue: getRootOperator(rootValue),
        nodeLabel: rootValue,
        rightNode: null
    }
    const newNodes = nodes.slice(1, nodes.length)
    if (newNodes.length > 0) {
        node.leftNode = nodes[0]
        node.rightNode = makeTree(newNodes, rootValue)
    } else {
        return nodes[0]
    }

    return node
}
// responseData parameter can be attribute's data or can be product targeting data,
// which will come from API call
export const getDataFromTree = (parentTree, responseData) => {
    const data = {
        operator: "AND",
        attributes: []
    }
    if (parentTree.nodeType === rootType) {
        data.operator = parentTree.nodeLabel
    }

    const attributeMap = new Map()
        responseData.forEach((item) => {
            const valueListMap = new Map()
            const {values} = item.operatorsAndValues[0]
            const {valueList} = values
            valueList.forEach((value) => {
                const {valueKey, displayName} = value
                valueListMap.set(valueKey, displayName)
            })
            const {attributeKey} = item
            attributeMap.set(attributeKey, valueListMap)
        })

        function findValues(key, valueList) {
            const valueListMap = attributeMap.get(key)
            return valueList.map((valueKey) => valueListMap.get(valueKey))
        }

    function traverseTree(tree) {
        if (tree.nodeType === rootType) {
            traverseTree(tree.leftNode)
            traverseTree(tree.rightNode)
        } else {
            if (tree.rightNode.nodeValue instanceof Array) {
                data.attributes.push({
                    attribute: tree.leftNode.nodeLabel,
                    operator: tree.nodeLabel,
                    value: findValues(tree.leftNode.nodeValue, tree.rightNode.nodeValue),
                })
            } else {
                data.attributes.push({
                    attribute: tree.leftNode.nodeLabel,
                    operator: tree.nodeLabel,
                    value: tree.rightNode.nodeLabel,
                })
            }
        }
    }
    traverseTree(parentTree)
    
    return data
}

export const convertToBoolean = (obj) => {
    let newObj = JSON.stringify(obj)
    newObj = JSON.parse(newObj)
    function internal(data) {
        Object.keys(data).forEach((key) => {
            const value = data[key]
            if (value && typeof value === "object" && !Array.isArray(value)) {
                data[key] = { ...convertToBoolean(value) }
            } else {
                data[key] = !!value
            }
        })
    }
    internal(newObj)
    return newObj
}

export const getDateTimeFromMillis = (millis) => {
    const dateTime = new Date(millis)
    const date = new Date(millis)
    date.setHours(0, 0, 0, 0)
    return {
        date: date.toLocaleDateString(),
        time: dateTime.toLocaleTimeString()
    };
}

export const getMillisFromDateTimeMoment = (date, time) => {
    const hoursInMillis = ((time.toDate().getHours()) * 60 * 60 * 1000)
    const mintuesInMillis = ((time.toDate().getMinutes()) * 60 * 1000)
    let newDate = date.toDate()
    newDate.setHours(0, 0, 0, 0)
    newDate.setTime(newDate.getTime() + hoursInMillis + mintuesInMillis)
    return newDate.getTime();
}

export const writeSummary = (summary, lineBreak) => {
    const { operator, attributes } = summary
    return attributes.map((item, index) => {
        let value = item.value
        if (value instanceof Array) {
            value = value.join(', ')
        }
        return <>
            {lineBreak && <br />}
            <span key={item}>
                <span className={styles.summaryOperators}>{index > 0 && item.attribute ? " " + operator + " " : ""}</span>
                {lineBreak && <br />}
                <span className={styles.summaryText}>{item.attribute} {item.operator} {value}</span>
            </span>
        </>
    })
}

export const writeProductDetailSummary = (summary, lineBreak) => {
    const { operator, attributes } = summary
    if(!attributes[0].attribute){
        return <span className={styles.productDetailsSummary}>{productSummarySelection}</span>
    }
    return attributes.map((item, index) => {
        let value = item.value;
        if (Array.isArray(value)) {
            value = value.join(', ');
        }
        return <>
            {lineBreak && <br />}
            <span key={item.attribute}>
                <span className={styles.summaryOperators}>{index > 0 && item.attribute ? " " + operator + " " : ""}</span>
                {lineBreak && <br />}
                <span className={styles.productDetailsSummary}>{item.attribute} {item.operator} 
                    {item.value && <span className={styles.productDetailsSummaryValue}> "{value}"</span>}
                </span>
            </span>
        </>
    })
}

// remove in next release
// export const getPeriscopeURL = (data) => {
//     const API_KEY = "ca61d32b-5082-4455-ba46-a105bd55";
//     var path = '/api/embedded_dashboard?data=' + escape(JSON.stringify(data));
//     var sha = new jsSHA('SHA-256', 'TEXT');
//     sha.setHMACKey(API_KEY, 'TEXT');
//     sha.update(path);
//     var signature = sha.getHMAC('HEX');

//     // Build and return final periscope URL
//     var url = 'https://www.periscopedata.com' + path + '&signature=' + signature;
//     return url;
// }

export const getRouteTitle = (pathName) => {
    const lastIndex = pathName.lastIndexOf('/');
    if (lastIndex > 0) {
        pathName = pathName.slice(0, lastIndex);
    }
    for (let route in routes) {
        if (routes[route] === pathName) {
            return route;
        }
    }
    return '';
};

export const nextStepValidtor = (isNextStepValid, currValue) => {
    if(Array.isArray(currValue?.value)) {
        if(currValue.value.length === 0) {
            isNextStepValid = false
        }
      } else {
        if(!currValue?.value) {
            isNextStepValid = false
        }
      }
        return isNextStepValid
}
